export default __webpack_public_path__ + "static/code-06cc976481705bac9e63b378c75e97df.jpg";